import { Component, inject, Input } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';
import { ContractService } from '@modules/universal-billing/contract/contract.service';
import { Observable } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContractRateType } from '@modules/universal-billing/contract/contract.enums';
import {
  ContractPaymentFormComponent
} from '@modules/universal-billing/contract/components/contract-payment-form/contract-payment-form.component';
import { ButtonModule } from '@primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-payments-form',
  standalone: true,
  imports: [
    ContractPaymentFormComponent,
    ButtonModule,
    TranslatePipe
  ],
  templateUrl: './contract-payments-form.component.html',
  styleUrl: './contract-payments-form.component.scss'
})
export class ContractPaymentsFormComponent extends BasicForm<any>{

  @Input() contract: RentalContract;
  @Input() afterSuccess: Function;

  form: FormGroup = new FormGroup({
    unitType: new FormControl(ContractRateType.FlatRateRent, Validators.required),
    flatRate: new FormControl(),
    coldRent: new FormControl(),
    totalPrepayment: new FormControl(),
    operatingCost: new FormControl(),
    heatingCost: new FormControl(),
    validFrom: new FormControl({value: null, disabled: true}),
  });

  _defaultService: ContractService = inject(ContractService);

  isEdit = true;

  ngOnInit() {
    this.patchResponseData({...this.contract });
  }

  convertToRequestData(data: any): any {
    return super.convertToRequestData({ ...this.contract, ...data});
  }

  submitAction(data: any): Observable<any> {
    return this._defaultService.patch(data, this.contract.id);
  }

  afterSuccessSubmit(res: any) {
    this.afterSuccess(res.data);
    super.afterSuccessSubmit(res);
  }
}
